
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

interface Article {
  id: string;
  title: string;
  summary: string;
  publishDate: string;
  readCount: number;
  category: string;
  isPaid: boolean;
  price: number;
}

export default function News() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState<Article | null>(null);

  const categories = [
    { id: 'all', name: '全部' },
    { id: 'office', name: '办公设备' },
    { id: 'photography', name: '摄影器材' },
    { id: 'electronics', name: '电子产品' },
    { id: 'conference', name: '会议设备' },
    { id: 'tech', name: '科技前沿' }
  ];

  const articles: Article[] = [
    {
      id: '1',
      title: '2025年办公设备智能化趋势：AI助力提升工作效率',
      summary: '深度解析2025年办公设备的智能化发展趋势，包括智能打印机、AI办公助手等先进设备的技术突破，以及在现代办公环境中的实际应用案例。文章详细分析了智能办公设备对传统工作模式的颠覆性影响...',
      publishDate: '2025-10-15',
      readCount: 15420,
      category: 'office',
      isPaid: true,
      price: 3
    },
    {
      id: '2',
      title: '专业摄影器材选购指南：从入门到专业的完整攻略',
      summary: '全面介绍摄影器材的选购技巧，从相机机身、镜头到三脚架、闪光灯等配件的选择要点。文章包含不同预算下的推荐方案，以及专业摄影师的实用建议...',
      publishDate: '2025-10-12',
      readCount: 8930,
      category: 'photography',
      isPaid: true,
      price: 3
    },
    {
      id: '3',
      title: '5G时代的电子产品创新：智能设备迎来新机遇',
      summary: '随着5G网络的普及，电子产品正迎来前所未有的创新机遇。本文分析了5G技术对智能手机、平板电脑、智能穿戴设备等产品的推动作用，以及未来发展趋势...',
      publishDate: '2025-10-10',
      readCount: 12650,
      category: 'electronics',
      isPaid: true,
      price: 3
    },
    {
      id: '4',
      title: '会议设备升级指南：打造高效的现代会议室',
      summary: '现代企业对会议效率的要求越来越高，专业的会议设备成为关键。文章深入分析了投影仪、音响系统、视频会议设备等核心设备的选择标准，以及如何构建完整的会议解决方案...',
      publishDate: '2025-10-08',
      readCount: 9870,
      category: 'conference',
      isPaid: true,
      price: 3
    },
    {
      id: '5',
      title: '无线办公时代：蓝牙键盘和鼠标的技术革新',
      summary: '无线办公设备正在改变我们的工作方式。本文详细介绍了最新蓝牙键盘和鼠标的技术特点，包括续航能力、连接稳定性、人体工学设计等方面的创新...',
      publishDate: '2025-10-05',
      readCount: 18750,
      category: 'office',
      isPaid: true,
      price: 3
    },
    {
      id: '6',
      title: '数码相机传感器技术突破：画质提升的关键因素',
      summary: '相机传感器技术的不断进步推动着摄影行业的发展。文章分析了最新的传感器技术，包括像素密度、感光度、动态范围等关键参数的提升，以及对摄影创作的影响...',
      publishDate: '2025-10-03',
      readCount: 7420,
      category: 'photography',
      isPaid: true,
      price: 3
    },
    {
      id: '7',
      title: '智能手机处理器性能大比拼：2025年旗舰芯片解析',
      summary: '2025年各大厂商推出的旗舰处理器在性能上都有显著提升。文章详细对比了主流芯片的性能表现，包括CPU、GPU、AI处理能力等方面的技术特点...',
      publishDate: '2025-10-10',
      readCount: 11200,
      category: 'electronics',
      isPaid: true,
      price: 3
    },
    {
      id: '8',
      title: '远程会议设备选择指南：后疫情时代的办公新常态',
      summary: '远程办公已成为新常态，优质的会议设备对提升沟通效率至关重要。文章介绍了各种远程会议设备的特点，包括摄像头、麦克风、音响等设备的选择要点...',
      publishDate: '2023-12-28',
      readCount: 13580,
      category: 'conference',
      isPaid: true,
      price: 3
    }
  ];

  const filteredArticles = selectedCategory === 'all' 
    ? articles 
    : articles.filter(article => article.category === selectedCategory);

  const handleReadMore = (article: Article) => {
    setSelectedArticle(article);
    setShowPaymentModal(true);
  };

  const handlePayment = () => {
    // 这里可以集成实际的支付逻辑
    setShowPaymentModal(false);
    alert('支付功能演示：实际使用时会跳转到支付页面');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-orange-500 to-orange-600 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl font-bold text-white mb-4">科技资讯</h1>
            <p className="text-xl text-orange-100 mb-8">
              获取最新的办公设备、摄影器材、电子产品和会议设备资讯
            </p>
            <div className="max-w-md mx-auto">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索文章..."
                  className="w-full px-4 py-3 pl-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="ri-search-line text-gray-400"></i>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 bg-gray-50 border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap gap-2 justify-center">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    selectedCategory === category.id
                      ? 'bg-orange-500 text-white'
                      : 'bg-white text-gray-600 hover:bg-orange-50 hover:text-orange-500'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Articles List */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Main Content */}
              <div className="lg:col-span-2">
                <div className="space-y-6">
                  {filteredArticles.map((article) => (
                    <article key={article.id} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow duration-200">
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex-1">
                          <div className="flex items-center space-x-2 mb-2">
                            <span className="px-2 py-1 bg-orange-100 text-orange-600 text-xs rounded-full">
                              {categories.find(cat => cat.id === article.category)?.name}
                            </span>
                            <span className="text-sm text-gray-500">{article.publishDate}</span>
                          </div>
                          <h2 className="text-xl font-semibold text-gray-800 mb-3 hover:text-orange-500 transition-colors cursor-pointer">
                            {article.title}
                          </h2>
                          <p className="text-gray-600 leading-relaxed mb-4">
                            {article.summary}
                          </p>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-4 text-sm text-gray-500">
                              <span className="flex items-center">
                                <i className="ri-eye-line mr-1"></i>
                                {article.readCount.toLocaleString()} 阅读
                              </span>
                            </div>
                            {article.isPaid && (
                              <Button
                                size="sm"
                                onClick={() => handleReadMore(article)}
                                className="flex items-center space-x-1"
                              >
                                <span>付费阅读</span>
                                <span className="text-xs"> ¥ {article.price} 元</span>
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>

                {/* Pagination */}
                {/* <div className="mt-12 flex justify-center">
                  <div className="flex items-center space-x-2">
                    <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">
                      <i className="ri-arrow-left-line"></i>
                    </button>
                    <button className="px-3 py-2 bg-orange-500 text-white rounded-lg cursor-pointer">1</button>
                    <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">2</button>
                    <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">3</button>
                    <span className="px-3 py-2 text-gray-500">...</span>
                    <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">10</button>
                    <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </div> */}
              </div>

              {/* Sidebar */}
              <div className="lg:col-span-1">
                <div className="space-y-6">
                 

                  {/* Subscription */}
                  <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg p-6 text-white">
                    <h3 className="text-lg font-semibold mb-2">订阅资讯</h3>
                    <p className="text-orange-100 text-sm mb-4">
                      订阅我们的科技资讯，第一时间获取最新动态
                    </p>
                    <div className="space-y-3">
                      <input
                        type="email"
                        placeholder="输入您的邮箱"
                        className="w-full px-3 py-2 rounded-lg text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white"
                      />
                      <Button variant="secondary" className="w-full bg-white text-orange-500 hover:bg-orange-50">
                        立即订阅
                      </Button>
                    </div>
                  </div>

                  {/* Tags */}
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">热门标签</h3>
                    <div className="flex flex-wrap gap-2">
                      {['智能办公', '摄影技巧', '电子产品', '会议设备', '办公效率', '数码相机', '智能手机', '投影仪', '蓝牙设备', '办公家具'].map((tag, index) => (
                        <span
                          key={index}
                          className="px-3 py-1 bg-gray-100 text-gray-600 text-sm rounded-full hover:bg-orange-100 hover:text-orange-600 transition-colors cursor-pointer"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Payment Modal */}
        {showPaymentModal && selectedArticle && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-md w-full p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-800">付费阅读</h3>
                <button
                  onClick={() => setShowPaymentModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              
              <div className="mb-6">
                <h4 className="font-medium text-gray-800 mb-2">{selectedArticle.title}</h4>
                <p className="text-sm text-gray-600 mb-4">
                  阅读完整文章需要支付 ¥{selectedArticle.price} 元
                </p>
                <div className="bg-gray-50 rounded-lg p-4 text-center">
                  <div className="w-32 h-32 bg-gray-200 rounded-lg mx-auto mb-3 flex items-center justify-center">
                    <i className="ri-qr-code-line text-4xl text-gray-400"></i>
                  </div>
                  <p className="text-sm text-gray-600 mb-2">使用支付宝扫码支付</p>
                  <p className="text-lg font-semibold text-orange-500">¥{selectedArticle.price}</p>
                </div>
              </div>
              
              <div className="flex space-x-3">
                <Button
                  variant="outline"
                  className="flex-1"
                  onClick={() => setShowPaymentModal(false)}
                >
                  取消
                </Button>
                <Button
                  className="flex-1"
                  onClick={handlePayment}
                >
                  确认支付
                </Button>
              </div>
            </div>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
